import { createSlice } from '@reduxjs/toolkit';
import {
  Item,
  UpSellData,
  Variant,
} from '../../../page-builder/interface/checkoutInterface';
import {
  ICurrentUpsellData,
  IPostUpsellVariant,
  ISelectedUpsellItems,
  IUpsellData,
} from '../../interface/postUpsellInterface';

export interface PostUpsellState {
  postUpsellData: UpSellData;
  upsellData: IUpsellData;
  currentUpsellData: ICurrentUpsellData;
  smartUpsellFunnelID: string;
  predefinedUpsellProduct: string;
  selectedVariantForSingleProduct: IPostUpsellVariant;
  selectedProductsForMultiProducts: ISelectedUpsellItems[];
  selectedUpsellItems: ISelectedUpsellItems[];
}

export const initialVariant: Variant = {
  ID: '',
  ImageURL: '',
  OriginalPrice: '',
  Price: '',
  Title: '',
  Quantity: 1,
};

export const initialItem: Item = {
  ID: '',
  ImageURL: '',
  Title: '',
  Variants: [initialVariant],
};
export const initialState: PostUpsellState = {
  postUpsellData: [initialItem],
  upsellData: {},
  currentUpsellData: {
    pageId: 0,
    isDownSell: false,
    downsell_id: '',
    upsellgroup_id: '',
    products: [
      {
        id: '',
        variants: [
          {
            productPrice: '',
            shippingType: {
              label: '',
              value: '',
            },
            displayPrice: '',
            shippingPrice: '',
            discountAmount: {
              type: '',
              value: '',
            },
            productVariants: {
              label: '',
              value: '',
              productPrice: '',
              productImage: '',
            },
            totalUpSellPrice: '',
          },
        ],
        assignedProducts: {
          label: '',
          value: 0,
        },
      },
    ],
    decline: {
      nextProduct: 0,
    },
    accept: {
      nextProduct: 0,
    },
  },
  selectedVariantForSingleProduct: {
    label: '',
    value: '',
    productPrice: '',
    productImage: '',
  },
  selectedProductsForMultiProducts: [],
  smartUpsellFunnelID: '',
  selectedUpsellItems: [],
  predefinedUpsellProduct: '',
};

export const postUpsellSlice = createSlice({
  name: 'postUpsell',
  initialState,
  reducers: {
    setPostUpsellData(state, action) {
      return { ...state, postUpsellData: action.payload };
    },
    setUpsellData(state, action) {
      return { ...state, upsellData: action.payload };
    },
    setCurrentUpsellData(state, action) {
      return {
        ...state,
        currentUpsellData: action.payload,
        selectedVariantForSingleProduct:
          initialState.selectedVariantForSingleProduct,
        selectedProductsForMultiProducts:
          initialState.selectedProductsForMultiProducts,
      };
    },
    setSelectedUpsellItems(state, action) {
      return { ...state, selectedUpsellItems: action.payload };
    },
    setSelectedVariantForSingleProduct(state, action) {
      return {
        ...state,
        selectedVariantForSingleProduct: action.payload,
      };
    },
    setSmartUpsellFunnelID(state, action) {
      return { ...state, smartUpsellFunnelID: action.payload };
    },
    setSelectedProductsForMultiProducts(state, action) {
      return {
        ...state,
        selectedProductsForMultiProducts: action.payload,
      };
    },
    setPredefinedUpsellProduct(state, action) {
      return { ...state, predefinedUpsellProduct: action.payload };
    },
  },
});

export const {
  setPostUpsellData,
  setCurrentUpsellData,
  setUpsellData,
  setSelectedUpsellItems,
  setSelectedVariantForSingleProduct,
  setSmartUpsellFunnelID,
  setSelectedProductsForMultiProducts,
  setPredefinedUpsellProduct,
} = postUpsellSlice.actions;

export default postUpsellSlice.reducer;
